import { createRoutine } from 'redux-saga-routines';

import {
  GET_PRODUCTION_DATA,
  UPDATE_PRODUCTION,
  CREATE_PRODUCTION,
  GET_COMPANIES,
  CLEAN_OPTIONS_VALUES,
  SET_PRODUCTION,
  GET_PRODUCTION_NAMES,
  CREATE_PRODUCTION_CASTS,
  SET_PROFESSIONS,
  SET_ROLES,
  UPDATE_PRODUCTION_PERFORMANCES,
  GET_VENUES,
  GET_LIBRETTIST_NAMES,
  CREATE_COMPOSER,
  SET_ADD_OPTION,
  GET_PRODUCTION_CASTS,
  GET_PRODUCTION_DATES,
  GET_ARTIST_PRODUCTION_DATES,
  GET_ARTISTS_SUGGESTIONS,
  UPDATE_MEDIA,
  CLIENT_REMOVE_MEDIA,
  GET_PRODUCTION_MEDIA_ATTRIBUTE_TYPES,
  GET_FESTIVALS,
  GET_PERFORMANCE_CITIES,
  CLEAR_PERFORMANCE_CITIES,
  GET_PERFORMANCE_STAGES,
  CLEAR_PERFORMANCE_STAGES,
  ADD_SEVERAL_MEDIA,
  CLEAR_PRODUCTION,
  GET_COMPANY_VENUES,
  GET_WORKS,
  GET_PRODUCTION_SYNOPSIS,
  DELETE_PRODUCTION_DOCUMENT,
  UPLOAD_PRODUCTION_DOCUMENTS,
  UPDATE_PRODUCTION_SYNOPSIS_DOCUMENTS,
  GET_PRODUCTION_IMAGES,
  GET_PRODUCTION_VIDEO,
  ADD_PRODUCTION_IMAGE,
  ADD_PRODUCTION_VIDEO,
  UPDATE_PRODUCTION_LIVESTREAM,
  GET_PRODUCTION_LIVESTREAMS,
  GET_COMPOSERS,
  GET_PRODUCTION_VIDEO_ON_DEMAND,
  UPDATE_VIDEO_ON_DEMAND,
  GET_VIDEO_COST_TYPES,
  GET_IMAGE_FORMATS,
  GET_VIDEO_FORMATS,
  CREATE_DIGITAL_EVENT,
  DELETE_DIGITAL_EVENT,
} from './constants';

export const getProductionDataAction = createRoutine(GET_PRODUCTION_DATA);
export const updateProductionAction = createRoutine(UPDATE_PRODUCTION);
export const createProductionAction = createRoutine(CREATE_PRODUCTION);
export const getCompaniesAction = createRoutine(GET_COMPANIES);
export const getArtistNamesAction = createRoutine(GET_PRODUCTION_NAMES);
export const getLibrettistsNamesAction = createRoutine(GET_LIBRETTIST_NAMES);
export const getVenuesAction = createRoutine(GET_VENUES);
export const createProductionCastAction = createRoutine(CREATE_PRODUCTION_CASTS);
export const getProductionCastAction = createRoutine(GET_PRODUCTION_CASTS);
export const updateProductionPerformancesAction = createRoutine(UPDATE_PRODUCTION_PERFORMANCES);
export const createComposerAction = createRoutine(CREATE_COMPOSER);
export const setProfessions = createRoutine(SET_PROFESSIONS);
export const setRoles = createRoutine(SET_ROLES);
export const getProductionDatesAction = createRoutine(GET_PRODUCTION_DATES);
export const getArtistsSuggestionsAction = createRoutine(GET_ARTISTS_SUGGESTIONS);
export const getProductionImagesAction = createRoutine(GET_PRODUCTION_IMAGES);
export const getProductionVideoAction = createRoutine(GET_PRODUCTION_VIDEO);
export const getMediaAttributes = createRoutine(GET_PRODUCTION_MEDIA_ATTRIBUTE_TYPES);
export const getFestivalsAction = createRoutine(GET_FESTIVALS);
export const getPerformanceCitiesAction = createRoutine(GET_PERFORMANCE_CITIES);
export const clearPerformanceCitiesAction = createRoutine(CLEAR_PERFORMANCE_CITIES);
export const getPerformanceStagesAction = createRoutine(GET_PERFORMANCE_STAGES);
export const clearPerformanceStagesAction = createRoutine(CLEAR_PERFORMANCE_STAGES);
export const uploadSeveralMediaAction = createRoutine(ADD_SEVERAL_MEDIA);
export const getWorksAction = createRoutine(GET_WORKS);
export const getProductionSinopsisAction = createRoutine(GET_PRODUCTION_SYNOPSIS);
export const getProductionImageFormatsAction = createRoutine(GET_IMAGE_FORMATS);
export const getProductionVideoFormats = createRoutine(GET_VIDEO_FORMATS);
export const updateProductionSynopsisDocumentsAction = createRoutine(UPDATE_PRODUCTION_SYNOPSIS_DOCUMENTS);
export const addProductionImageAction = createRoutine(ADD_PRODUCTION_IMAGE);
export const addProductionVideoAction = createRoutine(ADD_PRODUCTION_VIDEO);
export const getProductionLivestreamsAction = createRoutine(GET_PRODUCTION_LIVESTREAMS);
export const getProductionVideoOnDemandAction = createRoutine(GET_PRODUCTION_VIDEO_ON_DEMAND);
export const getComposersAction = createRoutine(GET_COMPOSERS);
export const getCompanyVenuesAction = createRoutine(GET_COMPANY_VENUES);
export const updateVideoOnDemandAction = createRoutine(UPDATE_VIDEO_ON_DEMAND);
export const updateLivestreamAction = createRoutine(UPDATE_PRODUCTION_LIVESTREAM);
export const getVideoCostTypesAction = createRoutine(GET_VIDEO_COST_TYPES);
export const createDigitalEventAction = createRoutine(CREATE_DIGITAL_EVENT);
export const deleteDigitalEventAction = createRoutine(DELETE_DIGITAL_EVENT);

// artist specific data
export const getArtistProductionDatesAction = createRoutine(GET_ARTIST_PRODUCTION_DATES);
export const uploadProductionDocumentsAction = createRoutine(UPLOAD_PRODUCTION_DOCUMENTS);

export function setProduction(production) {
  return {
    type: SET_PRODUCTION,
    payload: { production },
  };
}
export function clearProductionAction() {
  return {
    type: CLEAR_PRODUCTION,
    payload: {},
  };
}

export function cleanOptionsValuesAction(field) {
  return {
    type: CLEAN_OPTIONS_VALUES,
    payload: { field },
  };
}

export function setAddOption(addOption) {
  return {
    type: SET_ADD_OPTION,
    payload: { addOption },
  };
}

export function deleteProductionDocumentAction(documentId) {
  return {
    type: DELETE_PRODUCTION_DOCUMENT,
    payload: { id: documentId },
  };
}

export function clientRemoveMediaAction(mediaId, type) {
  return {
    type: CLIENT_REMOVE_MEDIA,
    payload: { id: mediaId, type },
  };
}

export function updateMediaAction(media, type) {
  return {
    type: UPDATE_MEDIA,
    payload: { entity: media, type },
  };
}
